import { render, staticRenderFns } from "./farm_order_list.vue?vue&type=template&id=3754d2fe&scoped=true"
import script from "./farm_order_list.vue?vue&type=script&lang=js"
export * from "./farm_order_list.vue?vue&type=script&lang=js"
import style0 from "./farm_order_list.vue?vue&type=style&index=0&id=3754d2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754d2fe",
  null
  
)

export default component.exports